export const enum DocumentTypeEnum {
    INVOICE = 'invoice',
    WAYBILL = 'waybill',
}
